import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const useValidationSchema = () => {
  const { t } = useTranslation();

  return yup.object({
    time: yup.string().required(t("ERRORS.COMMONS.REQUIRED")),
  });
};
